import { AuthRepository } from "../../api";
import { Auth } from "../../models/lib/entities/Auth";
import { handleChangeInputText } from "../../helpers";

export class EditUserController {
	constructor(context) {
		this.submit = this.submit.bind(context);
		this.changeAction = this.changeAction.bind(context);
		
		this.handleChange = e => handleChangeInputText(e, null, this.changeAction, context.state.values);

	}

	changeAction(values, id, reference) {

		const state = this.getState();
		
		state.values[reference] = values[reference];

		this.callback(state);
	}

	async submit(e) {
		e.preventDefault();

		const state = this.getState();

		state.errors["password"] = "";
		state.errors["confirmPassword"] = "";

		if( !state.values.password || !state.values.confirmPassword ){
			state.errors["password"] = "Preencha todos os campos.";
		}	else if(state.values.password !== state.values.confirmPassword ) {
			state.errors["password"] = "Senhas não são iguais!";
		} else {
			const auth = this.props.auth;
			const response = await auth.updatePassword(state.values.oldPassword, state.values.confirmPassword, "this.props.token");
			if(!response.error){
				Materialize.toast('Sucesso ao atualizar senha.', 4000);
			}else if(response.error.code == 604) {
				state.errors["oldPassword"] = "Senha incorreta";
			} 
		}

		return this.callback(state);
	}
}



// WEBPACK FOOTER //
// src/controllers/lib/EditUserController.js